import axios from 'axios';

import { API_URL } from '@/.env';

const http = axios.create({
  baseURL: API_URL,
});

http.interceptors.request.use(
  config => config,
  error => Promise.reject(error)
);

http.interceptors.response.use(
  response => response,
  error => new Promise(() => { throw error.response; })
);

export default http;
